<template>
    <div class="p-4">
        <div style="font-size: 12px">
            <div>
                <label class="pb-1 fw-bold fs-6">Conflicting Client</label>
            </div>
            <div>
                <text style="text-align: left; font-size: 12px"
                    >There is an existing client that has the same name and date of birth as the referral you are trying
                    to create.</text
                >
            </div>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <text>Name:</text>
                </div>
                <div class="col-12 col-lg-6">
                    <span class="text-capitalize">
                        {{ options.DisplayName.toLowerCase() }}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <text>MRN:</text>
                </div>
                <div class="col-12 col-lg-6">
                    <span>
                        {{ options.PatientIdNumber }}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <text>Date of Birth:</text>
                </div>
                <div class="col-12 col-lg-6">
                    <span>
                        {{ formatDate(options.DOB) }}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <text>Status:</text>
                </div>
                <div class="col-12 col-lg-6">
                    <span class="text-capitalize">
                        {{ PatientStatuses.getKeyUsingValue(options.Status).toLowerCase() }}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <text>Branch:</text>
                </div>
                <div class="col-12 col-lg-6">
                    <span>
                        {{ options.LocationName }}
                    </span>
                </div>
            </div>
            <div class="mt-1 d-flex">
                <input type="checkbox" id="ignoreConflict" :checked="options.isChecked" />
                <span class="ms-1">Ignore this conflict and create anyway</span>
            </div>
        </div>
        <hr />
        <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-light border border-secondary me-1" @click="ok()">Continue</button>
            <button type="button" class="btn btn-primary border border-primary" @click="closeDialog()">Cancel</button>
        </div>
    </div>
</template>

<script lang="ts" src="./ConflictPrompt.ts"></script>
